<app-page-breadcrumb pageTitle="Correos enviados"></app-page-breadcrumb>

<div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
  <!-- Header -->
  <div class="flex flex-col gap-4 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
    <div>
      <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">Correos enviados</h3>
      <p class="mt-0.5 text-sm text-gray-500 dark:text-gray-400">
        Historial de los correos que enviaste.
      </p>
    </div>
    <div class="flex items-center gap-2">
      <button
        (click)="toggleFilters()"
        class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3.5 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L14 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 018 21v-7.586L3.293 6.707A1 1 0 013 6V4z"></path>
        </svg>
        Filtros
      </button>
    </div>
  </div>

  <!-- Filtros -->
  @if (showFilters) {
    <div class="border-t border-gray-200 px-5 py-4 dark:border-gray-800 sm:px-6">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Estado</label>
          <select
            [(ngModel)]="filtroStatus" (ngModelChange)="buscar()"
            class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
            <option value="">Todos</option>
            @for (opt of statusOptions; track opt.value) {
              <option [value]="opt.value">{{ opt.label }}</option>
            }
          </select>
        </div>
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">ID de contacto</label>
          <input
            type="number" [(ngModel)]="filtroContactId" (ngModelChange)="buscar()" placeholder="Ej. 77"
            class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300" />
        </div>
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Desde</label>
          <input
            type="date" [(ngModel)]="filtroFrom" (ngModelChange)="buscar()"
            class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300" />
        </div>
        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Hasta</label>
          <input
            type="date" [(ngModel)]="filtroTo" (ngModelChange)="buscar()"
            class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300" />
        </div>
      </div>
      <div class="mt-3 flex justify-end">
        <button
          (click)="limpiarFiltros()"
          class="text-sm font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">
          Limpiar filtros
        </button>
      </div>
    </div>
  }

  <!-- Tabla -->
  <div class="border-t border-gray-200 dark:border-gray-800">
    @if (loading) {
      <div class="flex items-center justify-center gap-3 py-16">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
        <span class="text-sm text-gray-500 dark:text-gray-400">Cargando correos...</span>
      </div>
    } @else if (error) {
      <div class="m-5 rounded-lg bg-error-50 dark:bg-error-500/15 p-4 text-sm text-error-700 dark:text-error-400">
        {{ error }}
      </div>
    } @else if (correos.length === 0) {
      <!-- Empty state -->
      <div class="flex flex-col items-center justify-center py-16 px-6 text-center">
        <div class="flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 mb-4">
          <svg class="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
          </svg>
        </div>
        <h4 class="text-base font-medium text-gray-800 dark:text-white/90">No hay correos enviados</h4>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Cuando envíes correos a tus contactos, aparecerán aquí.
        </p>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full min-w-[920px] text-left">
          <thead>
            <tr class="border-b border-gray-200 dark:border-gray-800">
              <th class="px-5 py-3 text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Asunto</th>
              <th class="px-5 py-3 text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">De</th>
              <th class="px-5 py-3 text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Para</th>
              <th class="px-5 py-3 text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Estado</th>
              <th class="px-5 py-3 text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Fecha</th>
              <th class="px-5 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Aperturas</th>
              <th class="px-5 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Clics</th>
            </tr>
          </thead>
          <tbody>
            @for (correo of correos; track correo.id) {
              <tr
                (click)="verDetalle(correo)"
                class="cursor-pointer border-b border-gray-100 transition-colors hover:bg-gray-50 dark:border-gray-800 dark:hover:bg-white/[0.03]">
                <td class="px-5 py-4">
                  <p class="text-sm font-medium text-gray-800 dark:text-white/90 truncate max-w-[260px]">
                    {{ correo.subject || '(Sin asunto)' }}
                  </p>
                  @if (correo.purpose) {
                    <p class="text-xs text-gray-400 dark:text-gray-500">{{ correo.purpose }}</p>
                  }
                </td>
                <!-- De -->
                <td class="px-5 py-4">
                  <p class="text-sm text-gray-700 dark:text-gray-300 truncate max-w-[200px]">
                    {{ correo.senderName || correo.fromEmail }}
                  </p>
                </td>
                <!-- Para -->
                <td class="px-5 py-4">
                  @if (correo.recipientName) {
                    <p class="text-sm text-gray-700 dark:text-gray-300 truncate max-w-[200px]">{{ correo.recipientName }}</p>
                    @if (correo.recipientEmail) {
                      <p class="text-xs text-gray-400 dark:text-gray-500 truncate max-w-[200px]">{{ correo.recipientEmail }}</p>
                    }
                  } @else if (correo.recipientEmail) {
                    <p class="text-sm text-gray-700 dark:text-gray-300 truncate max-w-[200px]">{{ correo.recipientEmail }}</p>
                  } @else {
                    <p class="text-sm text-gray-400 dark:text-gray-500">—</p>
                  }
                </td>
                <td class="px-5 py-4">
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                    [class]="statusColor(correo.status)">
                    {{ statusLabel(correo.status) }}
                  </span>
                </td>
                <td class="px-5 py-4">
                  <p class="text-sm text-gray-700 dark:text-gray-300">{{ formatDate(correo.sentAt || correo.createdAt) }}</p>
                </td>
                <td class="px-5 py-4 text-center">
                  <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ correo.openCount }}</span>
                </td>
                <td class="px-5 py-4 text-center">
                  <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ correo.clickCount }}</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      <div class="flex flex-col gap-3 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
          <span>Mostrar</span>
          <select
            [ngModel]="pageSize" (ngModelChange)="changePageSize($event)"
            class="rounded-lg border border-gray-300 bg-white px-2 py-1 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
            @for (size of PAGE_SIZE_OPTIONS; track size) {
              <option [value]="size">{{ size }}</option>
            }
          </select>
          <span>de {{ globalTotalElements }} correos</span>
        </div>
        <div class="flex items-center gap-2">
          <button
            (click)="cambiarPagina(globalPage - 1)" [disabled]="!hasPrevious"
            class="inline-flex items-center rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Anterior
          </button>
          <span class="text-sm text-gray-600 dark:text-gray-400">
            Página {{ pageDisplay }} de {{ globalTotalPages || 1 }}
          </span>
          <button
            (click)="cambiarPagina(globalPage + 1)" [disabled]="!hasNext"
            class="inline-flex items-center rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Siguiente
          </button>
        </div>
      </div>
    }
  </div>
</div>

<!-- Modal de detalle -->
<app-correo-detail-modal
  [isOpen]="showDetailModal"
  [emailId]="selectedEmailId"
  (close)="cerrarModal()">
</app-correo-detail-modal>
